export default {"src":"/_next/static/media/FOXF.cf8ffc15.svg","height":18,"width":18};